import React, { useState, useRef } from 'react';

const MultiSelectFilter = ({ selected, allOptions, onSelect }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const containerRef = useRef(null);

  const availableOptions = allOptions.filter(
    (option) =>
      !selected.includes(option) &&
      option.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleTagRemove = (tagToRemove) => {
    const newSelection = selected.filter((tag) => tag !== tagToRemove);
    onSelect(newSelection);
  };

  const handleOptionClick = (option) => {
    const newSelection = [...selected, option];
    onSelect(newSelection);
    setSearchTerm('');
    setShowDropdown(false);
  };

  const handleInputFocus = () => {
    setShowDropdown(true);
  };

  // Close dropdown when clicking outside the component
  const handleBlur = (e) => {
    if (containerRef.current && !containerRef.current.contains(e.relatedTarget)) {
      setShowDropdown(false);
    }
  };

  return (
    <div className="multi-selector-container" ref={containerRef} onBlur={handleBlur} tabIndex="0">
      <div className="tags-container" onClick={() => setShowDropdown(true)}>
        {selected.map((tag) => (
          <span key={tag} className="tag">
            {tag} <span className="remove-tag" onClick={(e) => {
                e.stopPropagation(); // Prevents opening the dropdown
                handleTagRemove(tag);
              }}>&times;</span>
          </span>
        ))}
        <input
          type="text"
          className="search-input"
          placeholder="Buscar..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onFocus={handleInputFocus}
        />
      </div>

      {showDropdown && (
        <div className="options-dropdown">
          {availableOptions.length > 0 ? (
            availableOptions.map((option) => (
              <div
                key={option}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </div>
            ))
          ) : (
            <div>No se encontraron resultados</div>
          )}
        </div>
      )}
    </div>
  );
};

export default MultiSelectFilter;